var walkinInterviewTitle = '[Walk in Interview]';

function loadOnTabShown(els) {
  els.forEach(function (el) {
    $('#tab-dashboard a[href="#'+el+'"]').on('show.bs.tab', function (event) {
      switch (el) {
        case 'applied':
          $.getAppliedJobsDashboard(0)
          break
        case 'saved':
          $.getSavedJobsDashboard(0)
          break
        case 'walkedin':
          $.getWalkinJobsDashboard(0)
          break
      }
    })
  });
}

if ($('#pagename').val() === 'jobseekerdashboard') {
  function sub_nav_affix () {
    var dashboard_nav = $('#dashboard-scroll')
    var navigation = $('#navigation > .navigation-group')

    var offset = dashboard_nav.parent().prev().innerHeight() + 40

    if ($(window).width() < 768) {
      dashboard_nav.affix({ offset: { top: (offset) } })

      // init position on load
      dashboard_nav.css({ 'top': navigation.height() })

      dashboard_nav.on('affixed.bs.affix', function () { // fixed
        $(this).css({ 'top': navigation.height() })
        $(this).next().css({ 'padding-top': $(this).height() })
      })

      dashboard_nav.on('affixed-top.bs.affix', function () { // top
        $(this).css({ 'top': 'auto' })
        $(this).next().css({ 'padding-top': '0px' })
      })
    }else {
      dashboard_nav.on('affixed.bs.affix', function () { // top
        $(this).css({ 'top': 'auto' })
        $(this).next().css({ 'padding-top': '0px' })
      })
    }
  }

  $(document).ready(function () {
    sub_nav_affix()

    $('.date_picker').combodate({
          minYear: 1955,
          smartDays: true,
          maxYear: n,
          firstItem: 'name',
          customClass: 'form-control text-capitalize'
    });

    /******************************************* Jobseeker Saved Jobs Listing ********************************/
    $.getSavedJobsDashboard = function (page) {
      var jsonData = {
        '_token': $('meta[name="csrf-token"]').attr('content'),
        '_method': 'GET'
      }

      var request = $.ajax({
        url: canvas_url + 'api/jobseeker/savedjobs',
        data: jsonData,
        type: 'GET',
        crossDomain: true,
        dataType: 'json'
      })

      $('#spinner').show()
      $('#savedjobs_listing').html('')

      request.done(function (data) {
        $('#spinner').hide()

        if (data.status == 'success') {
          var job = data.data
          var current = job.length
          var resultDiv = ''
          var joburl = ''
          var statusBar = ''
          var setClass = ''
          var setClass_h = ''
          var featuredBar = ''
          var hightlightAction = ''
          var clogo = ''
          var joburl = ''
          var applylink = ''
          var source = ''
          var applied_class = ''
          var count=0; 

          for (var i = 0; i < current; i++) {

            if(job[i].job_applied == "false")
            {
              count++;
              if (job[i].company_privacy == 'private' || job[i].logo == null) {
                job[i].logo = 'https://s3-ap-southeast-1.amazonaws.com/brightan-assets/images/others/v1/private-company.jpg'
              }

              // job link
              var jobName = job[i].title
              jobName = jobName.replace(/\s+/g, '-').toLowerCase()
              joburl = canvas_url + 'job/' + job[i].job_id + '-' + jobName

              // applylink = canvas_url + 'job/apply-job?job_id=' + job[i].job_id;

              // source link
              var sourceName = job[i].company_name
              sourceName = sourceName.replace(/\s+/g, '-').toLowerCase()
              source = canvas_url + 'company/' + job[i].company_id + '-' + sourceName
              source = canvas_url + 'company/' + job[i].company_id + '-' + job[i].company_slug

              applylink = (job[i].is_walkin == 1) ? joburl : canvas_url + 'job/apply-job?job_id=' + job[i].job_id
              if (job[i].apply_direct != null && job[i].apply_direct == 'yes') {
                applylink = job[i].apply_link
              }

              // attributes for apply button
              var apply_btn_class = (job[i].is_walkin == 1) ? 'btn-info' : 'btn-default disabled';
              var apply_btn_icon = (job[i].is_walkin == 1) ? 'fa-building-o' : 'fa-check';
              var apply_btn_title = (job[i].is_walkin == 1) ? 'Walk-in Interview' : 'Applied'

              if (job[i].job_applied == 'false' && job[i].status == 'published' && job[i].is_walkin != 1) {
                apply_btn_icon = 'fa-pencil-square-o'
                apply_btn_title = 'Apply Now'
                apply_btn_class = 'btn-default'
              }

              if (job[i].status != 'published') {
                apply_btn_title = 'Expired'
                apply_btn_icon = 'fa-times'
              }

              applied_class = '<span><a href="' + applylink + '" onclick="sendJobIdSocialCredit(\SC_MYPAGE_SAVED_JOB_APPLY\,\'' + job[i].job_id + '\',\'\job\');" data-toggle="tooltip" title="' + apply_btn_title + '" class="btn ' + apply_btn_class + ' xs-pl-30 xs-pr-30"><i class="fa ' + apply_btn_icon + '"></i> ' + apply_btn_title + '</a></span>'

              if (job[i].area != '') {
                job[i].area = job[i].area + ' ,'
              }

              if (job[i].final_salary == 'RM' || job[i].final_salary == 'RM1-RM1' || job[i].final_salary == 'RMRM1' || job[i].final_salary == '') { job[i].final_salary = txt_negotiable; }

              var jobTitle = (job[i].is_walkin == 1) ? walkinInterviewTitle + ' ' + job[i].title : job[i].title
              
              resultDiv += '<div class="col-md-12 job-list-wrap minimize">\
                <div class="job-list b b-1 b-default b-r-4 p-relative bg-white box-shadow xs-mb-20 b-r-0-xs b-left-0-xs b-right-0-xs">\
                    <div class="xs-p-20">\
                        <div class="xs-pr-15 pull-left">\
                            <a target="_blank" class="img-thumb img-center" href="">\
                                <img src="'+ job[i].logo + '" alt="' + job[i].title + '" class="img-responsive w-120-sm w-60-xs w-100p">\
                            </a>\
                        </div>\
                        <div class="job-list-title">\
                            <h4 class=" xs-mt-0 xs-mb-0 text-capitalize text-bold"><a class="text-dark" onclick="sendJobIdSocialCredit(\SC_MYPAGE_SAVED_JOB_CLICKED\,\'' + job[i].job_id + '\',\'\job\');" target="_blank" href="'+ joburl + '">' + jobTitle + '</a></h4>\
                            <p class=" text-capitalize xs-mb-0"><a class="text-dark" target="_blank" onclick="sendJobIdSocialCredit(\SC_MYPAGE_SAVED_COMPANY_CLICKED\,\'' + job[i].company_id + '\',\'\company\');" href="'+ source + '">' + job[i].company_name + '</a></p>\
                            <div class="text-left xs-mt-5">\
                                <span class="xs-mr-5 text-grey">'+ job[i].created_at_human + '</span>\
                            </div>\
                        </div>\
                        <div class="job-list-info xs-mt-10">\
                            <p class="xs-mb-5">\
                                <span class="d-inline-block text-nowrap xs-mr-10 pointer text-primary"><i class="fa fa-usd w-15"></i>'+ job[i].final_salary + '</span>\
                                <span class="d-inline-block text-nowrap xs-mr-10"><i class="fa fa-briefcase w-15"></i> '+ job[i].job_type + '</span>\
                            </p>\
                            <p class="xs-mb-0"><i class="fa fa-map-marker w-15"></i> '+ job[i].area + '' + job[i].state + '</p>\
                        </div>\
                    </div>\
                    <div class="job-list-action o-flow-hidden">\
                        <span><a href="#" data-toggle="tooltip" title="Remove Job" data-id="'+ job[i].id + '" class="delete-savedjob btn btn-default xs-pl-30 xs-pr-30"><i class="fa fa-trash-o"></i> Remove</a></span>\
                        '+ applied_class + '\
                    </div>\
                </div>\
              </div>';
            }
          }
          $('#savedjobs_total').html(count);
          $('#savedjobs_listing').html(resultDiv)
          $('[data-toggle="tooltip"]').tooltip()
          $('.fb-share-button').bind('click', function () {
            var id = $(this).attr('data-id')
            var url = $(this).attr('data-url')
            FB.ui({
              method: 'share',
              href: url // 'http://54.169.110.239/job/464-social-media-customer-service-specialist',
            }, function (response) { })
          })

          $('.delete-savedjob').bind('click', function () {
            var id = $(this).attr('data-id')

            swal({
              title: txt_are_u_sure,
              text: txt_remove_job,
              type: 'warning',
              width: 450,
              showCancelButton: true,
              confirmButtonText: 'Yes',
              confirmButtonClass: 'btn btn-primary w-100p-xs',
              cancelButtonText: 'No, Thank you',
              cancelButtonClass: 'btn btn-default sm-ml-20 xs-ml-0 sm-mt-0 xs-mt-10 w-100p-xs',
              buttonsStyling: false
            }).then(function () {
              $.deleteSavedJobDashboard(id)
              swal({
                title: txt_done_label,
                text: txt_job_is_deleted,
                type: 'success',
                width: 450,
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-primary w-100p-xs',
                buttonsStyling: false
              })
            })
          })
        } else {
          $('#savedjobs_listing').html('<div style="text-align:center"><h5 class="text-red">' + txt_no_job_found + '</h5></div>');
        }
      })

      request.fail(function (jqXHR, textStatus) {
        $('#spinner').hide()
        $('#savedjobs_listing').html('<div style="text-align:center"><h5 class="text-red">Error</h5></div>')
      })
    }

    /*******************************************Delete Saved Job ********************************/
    $.deleteSavedJobDashboard = function (id) {
      var jsonData = {
        '_token': $('meta[name="csrf-token"]').attr('content'),
        '_method': 'DELETE'
      }

      var request = $.ajax({
        url: canvas_url + 'api/job/saved/' + id,
        data: jsonData,
        type: 'DELETE',
        crossDomain: true,
        dataType: 'json'
      })

      $('#spinner').show()

      request.done(function (data) {
        $('#spinner').hide()

        if (data.status == 'success') {
          $.getSavedJobsDashboard()
        } else {

        }
      })

      request.fail(function (jqXHR, textStatus) {

      })
    }

    /*******************************************Jobseeker Applied Jobs Listing ********************************/
    $.getAppliedJobsDashboard = function (page) {
      var sort_by = 'applied_id'
      var filter_by = 'all'
      var orderby = 'DESC'
      var limit = 10
      var start_limit = (page - 1) * limit
      start_limit = (start_limit < 0) ? 0 : start_limit

      var jsonData = {
        'applicationsStatus': filter_by,
        sort_by: sort_by,
        orderby: orderby,
        start: start_limit,
        noOfRecords: limit,
        '_token': $('meta[name="csrf-token"]').attr('content'),
        '_method': 'GET'
      }

      var request = $.ajax({
        url: canvas_url + 'api/jobseeker/appliedjobs',
        data: jsonData,
        type: 'GET',
        crossDomain: true,
        dataType: 'json'
      })

      $('#spinner').show()
      $('#appliedjobListing').html('')

      request.done(function (data) {
        $('#spinner').hide()

        if (data.status == 'success') {
          var job = data.data
          var current = job.length
          var count = data.totalRecords
          $('#appliedjobs_total').html(count)
          var resultDiv = ''
          var joburl = ''
          var statusBar = ''
          var setClass = ''
          var setClass_h = ''
          var featuredBar = ''
          var hightlightAction = ''
          var clogo = ''
          var joburl = ''
          var applylink = ''
          var source = ''
          var save_class = ''
          var applied_class = ''
          var hightlighted_text = ''
          var action_btn = ''
          var company_url = ''
          var appliedstatus = ''
          var stats = ''
          var sharebutton = ''

          for (var i = 0; i < current; i++) {
            stats = ''
            
            clogo = (job[i].logo != null && job[i].logo != '') ? job[i].logo : job[i].category_pic
            company_url = canvas_url + 'company/' + job[i].company_id + '-' + job[i].company_slug

            if (job[i].company_privacy == 'private') {
              clogo = 'https://s3-ap-southeast-1.amazonaws.com/brightan-assets/images/others/v1/private-company.jpg'
              company_url = '#'
            }

            if (job[i].seo_link == null || typeof job[i].seo_link === undefined) {
              joburl = canvas_url + 'job/' + job[i].job_id + '-' + FilterURL(job[i].title)
            } else {
              joburl = canvas_url + 'job/' + job[i].job_id + '-' + job[i].seo_link
            }

            applylink = canvas_url + 'job/apply-job?job_id=' + job[i].job_id
            source = ''

            if (job[i].apply_direct != null && job[i].apply_direct == 'yes') {
              applylink = job[i].apply_link
              source = '<a class="right link-success-o comp" href="' + applylink + '" target="_blank"> ' + job[i].source + '</a>'
            }

            if (job[i].final_salary == 'RM' || job[i].final_salary == 'RM1-RM1' || job[i].final_salary == 'RMRM1' || job[i].final_salary == '') {
              job[i].final_salary = txt_negotiable;
            }

            if (job[i].is_featured == '1') {
              setClass_h = 'featured'
            }

            appliedstatus = ''
            action_btn = ''

            if (job[i].status == 'Pending' || job[i].status == 'pending' || job[i].status == 'kiv') {
              appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-warning">' + txt_pending + '</span>'
            }

            if (job[i].status == 'Success' || job[i].status == 'hired') {
              appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-success">' + txt_success + '</span>'
            }

            if (job[i].status == 'Rejected' || job[i].status == 'rejected') {
              appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-danger">' + txt_rejected + '</span>'
            }

            if (job[i].status == 'Accepted interview') {
              appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-success">' + txt_accepted_interview + '</span>';
            }

            if (job[i].status == 'Interested. Shorlisted.') {
              appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-success">' + txt_interested + '. ' + txt_shortlisted + '</span>';
            }

            if (job[i].status == 'Not Interested. Shorlisted.') {
              appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-success">' + txt_not_interested + '. ' + txt_shortlisted + '</span>';
            }

            if (job[i].status == 'Rejected interview') {
              statusBar = '<a class="link rejected-applied">' + txt_rejected_interview + '. <i class="mdi mdi-close-circle-outline"></i> </a>';
            }

            if (job[i].status == 'Shorlisted' || job[i].status == 'shortlisted') {
              appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-success">' + txt_shortlisted + '</span>';

              if (job[i].jobseeker_status == 'Interested') {
                appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-success">' + txt_interested + '. ' + txt_shortlisted + '</span>'
                action_btn = ''
              } else if (job[i].jobseeker_status == 'Not Interested') {
                appliedstatus = '<span class="d-inline-block xs-mr-10 label label-normal label-success">' + txt_not_interested + '. ' + txt_shortlisted + '</span>'
                action_btn = ''
              } else {
                action_btn = '<div class="text-center job-dashboard-shorlisted alert alert-dismissable xs-mb-0" style="padding: 4px 10px !important">\
                      <a href="#" class="hide close" data-dismiss="alert" aria-label="close">&times;</a>\
                      <span class="text-white">'+yay+' '+shortlisted+' <button data-id="'+ job[i].id + '" data-page="' + page + '" class="btn btn-sm btn-success shorlist_action_testing text-bold text-white link pointer btn-respond" style="background-color: #fff; color:#00d6a2; width: 100px; text-decoration: none;:hover {background-color: yellow};"><b>'+respon+'</b></button></span>\
                      <div class="clearfix"></div>\
                  </div>';
              }
            }

            sharebutton = (job[i].status == 'expired')
              ? '<span><a data-toggle="tooltip" title="Expired" class="btn btn-default disabled xs-pl-30 xs-pr-30"><i class="fa fa-times"></i> Expired</a></span>'
              : '<span><a style="cursor:pointer;" class="btn btn-default fb-share-button" onclick="sendJobIdSocialCredit(\SC_MYPAGE_APPLIED_JOB_SHARE\,\'' + job[i].job_id + '\' , \'\job\'\);" data-id="396192" data-url="' + joburl + '"><i class="fa fa-share"></i> Share</a></span>';

            resultDiv += '<div class="col-md-12 job-list-wrap minimize">\
                <div class="job-list b b-1 b-default b-r-4 p-relative bg-white box-shadow xs-mb-20 b-r-0-xs b-left-0-xs b-right-0-xs">\
                  <div class="xs-p-20 xs-pb-15 pointer" onclick="openURL('+ canvas_url + 'jobseeker/timeline/' + job[i].apply_id_hashed + ', \'_blank\', event)">\
                      <div class="xs-pr-15 pull-left">\
                          <a target="_blank" class="img-thumb img-center" href="'+ joburl + '">\
                          <img src="'+ clogo + '" alt="' + job[i].title + '" class="img-responsive w-120-sm w-60-xs w-100p"></a>\
                      </div>\
                      <div class="job-list-title">\
                          <h4 class=" xs-mt-0 xs-mb-0 text-capitalize text-bold"><a class="text-dark" onclick="sendJobIdSocialCredit(\SC_MYPAGE_APPLIED_JOB_CLICKED\,\'' + job[i].job_id + '\' , \'\job\'\);"  target="_blank" href="'+ joburl + '">' + job[i].title + '</a></h4>\
                          <p class=" text-capitalize xs-mb-0"><a class="text-dark" onclick="sendJobIdSocialCredit(\SC_MYPAGE_APPLIED_COMPANY_CLICKED\,\'' + job[i].company_id + '\' , \'\company\'\);" target="_blank" href="' + company_url + '">' + job[i].company_name + '</a></p>\
                          <div class="text-left xs-mt-5">\
                              <span class="xs-mr-5 text-grey">'+ txt_applied + ' ' + job[i].apply_created_at + '</span>\
                          </div>\
                      </div>\
                      <div class="job-list-info xs-mt-10">\
                          <p class="xs-mb-5"> '+ appliedstatus + '\
                              <span class="d-inline-block text-nowrap xs-mr-10 pointer text-primary"><i class="fa fa-usd w-15"></i> '+ job[i].final_salary + '</span>\
                              <span class="d-inline-block text-nowrap xs-mr-10"><i class="fa fa-briefcase w-15"></i> '+ job[i].job_type + '</span>\
                          </p>\
                          <p class="xs-mb-0"><i class="fa fa-map-marker w-15"></i> '+ job[i].area + ', ' + job[i].state + '</p>\
                          <div class="text-left b-top xs-mt-10 xs-pt-5" style="min-height:26px">\
                              <small class="xs-mb-0 text-grey">'+ job[i].stats + '</small>\
                          </div>\
                      </div>\
                  </div>\
                  <div class="job-list-action o-flow-hidden">'+ sharebutton + '\
                      <span>\
                          <a href="'+ canvas_url + 'jobseeker/timeline/' + job[i].apply_id_hashed + '" onclick="sendJobIdSocialCredit(\SC_MYPAGE_APPLIED_JOB_VIEW\,\'' + job[i].job_id + '\' , \'\job\'\);" class="btn btn-default text-primarybtn btn-default text-primary" target="_blank"><i class="fa fa-eye"></i> View Progress</a>\
                      </span>\
                  </div>'+ action_btn + '\
                </div>\
              </div>'
          }

          $('#appliedjobListing').html(resultDiv)

          $('#AppliedJobPaging').show()
          document.getElementById('AppliedJobPaging').innerHTML = Paging('AppliedJobListing', start_limit, page, count, limit)

          // layout();
          $('.mytooltip').tooltip()
          $('.fb-share-button').bind('click', function () {
            var id = $(this).attr('data-id')
            var url = $(this).attr('data-url')
            FB.ui({
              method: 'share',
              href: url
            }, function (response) { })
          })

          $('.replace-resume').bind('click', function () {
            var id = $(this).attr('data-id')
            var applyID = $(this).attr('data-apply')
            var jobID = $(this).attr('data-job')
            swal({
              title: txt_are_u_sure,
              text: txt_replace_resume,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: txt_confirm_replace,
              closeOnConfirm: true
            }, function () {
              $('#replace_apply_id').val(applyID)
              $('#replace_resume_id').val(id)
              $('#replace_job_id').val(jobID)

              $('#replace-resume').modal('show')
            })
          })

          $('.shorlist_action_testing').on('click', function () {
            var id = $(this).attr('data-id')
            var page = $(this).attr('data-page')

            swal({
              title: shortlisted,
              text: employeer,
              width: 450,
              showCancelButton: true,
              confirmButtonText: yes_interested,
              confirmButtonClass: 'btn btn-primary ml-10p w-100p-xs',
              cancelButtonText: no_interested,
              cancelButtonClass: 'btn btn-default sm-ml-20 xs-ml-0 sm-mt-0 xs-mt-10 w-100p-xs mr-10p',
              buttonsStyling: false
            }).then(function () {
              swal({
                title: confirm,
                text: interested,
                type: 'warning',
                width: 450,
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: txt_yes,
                confirmButtonClass: 'btn btn-primary ',
                cancelButtonText: txt_no,
                cancelButtonClass: 'btn btn-default xs-ml-20 '
              }).then(function () {
                var jsonData = {
                  'status': 1,
                  'id': id,
                  '_token': $('meta[name="csrf-token"]').attr('content'),
                  '_method': 'PUT'
                }
                var request = $.ajax({
                  url: canvas_url + 'api/jobseeker/appliedjobs/' + id,
                  data: JSON.stringify(jsonData),
                  type: 'PUT',
                  crossDomain: true,
                  contentType: "application/json",
                  dataType: 'json'
                })
                request.done(function (data) {
                  if (data.status == 'success') {
                    swal({
                      title: txt_done_label, 
                      text: respon_yes, 
                      type: 'success', 
                      confirmButtonText: txt_oke_label,
                    })
                    $.getAppliedJobsDashboard(page)
                  } else {
                    swal('Opps', issue, 'warning')
                  }
                })

                request.fail(function (jqXHR, textStatus) {
                  swal('Opps', 'There is some issue. Please try again.', 'warning')
                })

              }).catch(swal.noop)
            }, function (dismiss) {
              if (dismiss === 'cancel') {
                swal({
                  title: confirm,
                  text: not_interested_job,
                  type: 'warning',
                  width: 450,
                  showCancelButton: true,
                  buttonsStyling: false,
                  confirmButtonText: txt_yes,
                  confirmButtonClass: 'btn btn-primary',
                  cancelButtonText: txt_no,
                  cancelButtonClass: 'btn btn-default xs-ml-20'
                }).then(function () {
                  var jsonData = {
                    'status': 0,
                    'id': id,
                    '_token': $('meta[name="csrf-token"]').attr('content'),
                    '_method': 'PUT'
                  }
                  var request = $.ajax({
                    url: canvas_url + 'api/jobseeker/appliedjobs/' + id,
                    data: jsonData,
                    type: 'PUT',
                    crossDomain: true,
                    dataType: 'json'
                  })
                  request.done(function (data) {
                    if (data.status == 'success') {
                      swal({
                        title: txt_done_label, 
                        text: intrsted_mdl_reject_success, 
                        type: 'success', 
                        confirmButtonText: txt_oke_label,
                      })
                      $.getAppliedJobsDashboard(page)
                    } else {
                      swal('Opps', issue, 'warning')
                    }
                  })
                  request.fail(function (jqXHR, textStatus) {
                    swal('Opps', 'There is some issue. Please try again.', 'warning')
                  })


                }).catch(swal.noop)
              }
            })
          })

        } else {
          $('#appliedjobListing').html('<div style="text-align:center"><h5 class="text-red">' + txt_no_job_found + '</h5></div>')
          $('#AppliedJobPaging').hide()
        }
      })

      request.fail(function (jqXHR, textStatus) {
        $('#spinner').hide()
        $('#AppliedJobPaging').hide()
        $('#appliedjobListing').html('<div style="text-align:center"><h5 class="text-red">Error</h5></div>')
      })
    }

    /*******************************************Jobseeker Walk in Interview Jobs Listing ********************************/
    $.getWalkinJobsDashboard = function (page) {
      var jsonData = {
        '_token': $('meta[name="csrf-token"]').attr('content'),
        '_method': 'GET'
      }

      var request = $.ajax({
        url: canvas_url + 'api/jobseeker/walkinjobs',
        data: jsonData,
        type: 'GET',
        crossDomain: true,
        dataType: 'json'
      });

      $('#spinner').show();
      $('#walkinjobs_listing').html('');

      request.done(function (data) {
        $('#spinner').hide()

        if (data.status == 'success') {
          var job = data.data
          var current = job.length
          $('#walkinjobs_total').html(current)

          var resultDiv = ''
          var clogo = ''
          var joburl = ''
          var source = ''

          for (var i = 0; i < current; i++) {
            clogo = (job[i].company_privacy == 'private' || job[i].logo == null)
              ? 'https://s3-ap-southeast-1.amazonaws.com/brightan-assets/images/others/v1/private-company.jpg'
              : job[i].logo

            // job link
            var jobName = job[i].title;
            jobName = jobName.replace(/\s+/g, '-').toLowerCase();
            joburl = canvas_url + 'job/' + job[i].job_id + '-' + jobName;

            // source link
            var sourceName = job[i].company_name;
            sourceName = sourceName.replace(/\s+/g, '-').toLowerCase();
            source = canvas_url + 'company/' + job[i].company_id + '-' + sourceName;
            source = canvas_url + 'company/' + job[i].company_id + '-' + job[i].company_slug;

            // walkin info
            var jobwalkinDate = moment(job[i].walkin_date).format("DD MMMM YYYY");
            var jobwalkinLocation = (job[i].walkin_url != '') ? '<a target="_blank" href="' + job[i].walkin_url + '">' + job[i].walkin_place + '</a>' : job[i].walkin_place

            var jobTitle = walkinInterviewTitle + ' ' + job[i].title

            resultDiv += '<div class="job-list-wrap minimize">\
                  <div class="job-list b b-1 b-default b-r-4 p-relative bg-white box-shadow xs-mb-20 b-r-0-xs b-left-0-xs b-right-0-xs">\
                      <div class="xs-p-0 pointer">\
                          <div class="xs-p-20">\
                              <div class="xs-pr-15 pull-left">\
                                  <a target="_blank" href="'+ source + '" class="img-thumb img-center">\
                                      <img src="'+ clogo + '" alt="' + job[i].title + '" class="img-responsive w-120-sm w-60-xs w-100p">\
                                  </a>\
                              </div>\
                              <div class="job-list-title">\
                                  <h4 class=" xs-mt-0 xs-mb-0 text-capitalize text-bold"><a class="text-dark" target="_blank" href="'+ joburl + '">' + jobTitle + '</a></h4>\
                                  <p class=" text-capitalize xs-mb-0"><a class="text-dark" target="_blank" href="'+ source + '">' + sourceName + '</a></p>\
                              </div>\
                              <div class="job-list-info xs-mt-10">\
                                  <div class="walkin-info">\
                                      <div class="row">\
                                          <div class="col-md-12">\
                                              <p class="xs-mb-5">\
                                                  <span class="text-bold inline-block">'+ txt_loc1 + ':</span>\
                                                  <span class="inline-block">'+ jobwalkinLocation + '</span>\
                                              </p>\
                                          </div>\
                                          <div class="col-md-12">\
                                              <p class="xs-mb-5">\
                                                  <span class="inline-block text-bold">'+ txt_address + ':</span>\
                                                  <span class="inline-block">'+ job[i].walkin_address + '</span>\
                                              </p>\
                                          </div>\
                                      </div>\
                                      <hr class="xs-mt-10 xs-mb-10" />\
                                      <div class="row">\
                                          <div class="col-md-6">\
                                              <p class="xs-mb-0">\
                                                  <span class="text-bold inline-block">'+ txt_date + ':</span>\
                                              </p>\
                                              <p class="xs-mb-5"><i class="fa fa-calendar"></i>\
                                                  <span>'+ jobwalkinDate + '</span>\
                                              </p>\
                                          </div>\
                                          <div class="col-md-6">\
                                              <p class="xs-mb-0">\
                                                  <span class="text-bold inline-block">'+ txt_time + ':</span>\
                                              </p>\
                                              <p class="xs-mb-5"><i class="fa fa-clock-o"></i>\
                                                  <span>'+ job[i].walkin_from + ' - ' + job[i].walkin_to + '</span>\
                                              </p>\
                                          </div>\
                                      </div>\
                                  </div>\
                              </div>\
                          </div>\
                        </div>\
                      <div class="job-list-action o-flow-hidden">\
                          <span><a href="'+ joburl + '" target="_blank" data-toggle="tooltip" title="" class="btn btn-info xs-pl-30 xs-pr-30" data-original-title="Walk-in Interview"><i class="fa fa-building-o"></i> Walk-in Interview</a></span>\
                      </div>\
                  </div>\
              </div>';
          }
          
          $('#walkinjobs_listing').html(resultDiv);
          $('[data-toggle="tooltip"]').tooltip();

        } else {
            $('#walkinjobs_listing').html('<div style="text-align:center"><h5 class="text-red">' + txt_no_job_found + '</h5></div>');
          }
      });
      
      request.fail(function (jqXHR, textStatus) {
        $('#spinner').hide()
        $('#walkinjobs_listing').html('<div style="text-align:center"><h5 class="text-red">Error</h5></div>')
      });
    }
    //================================ End of Walk in Interview MK ========================================

    $('.savealert_dashboard').bind('click', function () {
      $.validator.setDefaults({
        submitHandler: function () {
          console.log('submitted!')
        }
      })

      $('#form_jobseeker_alert_dashboard').validate({
        rules: {
          jobseeker_alert_jobtitle_dashboard: { required: true },
          jobseeker_alert_jobtype_dashboard: { required: true },
          jobseeker_alert_expected_salary_dashboard: { required: true },
          jobseeker_alert_industry_dashboard: { required: true },
          jobseeker_alert_location_country_dashboard: { required: true },
          jobseeker_alert_location_state_dashboard: { required: true },
          jobseeker_alert_location_city_dashboard: { required: true }
        },
        messages: {
          jobseeker_alert_jobtitle_dashboard: { required: 'This field is required' },
          jobseeker_alert_jobtype_dashboard: { required: 'This field is required' },
          jobseeker_alert_expected_salary_dashboard: { required: 'This field is required' },
          jobseeker_alert_industry_dashboard: { required: 'This field is required' },
          jobseeker_alert_location_country_dashboard: { required: 'This field is required' },
          jobseeker_alert_location_state_dashboard: { required: 'This field is required' },
          jobseeker_alert_location_city_dashboard: { required: 'This field is required' }
        },
        submitHandler: function () {
          var title = 'Job Alert Dashboard'
          var keywords = $('#jobseeker_alert_jobtitle_dashboard').val()
          var prefer_locations = $('#jobseeker_alert_location_state').val()// $("#jobalert-state").val();
          var prefer_categories = $('#jobseeker_alert_industry_dashboard').val()
          var jobalert_city = $('#jobseeker_alert_location_city_dashboard').val()
          var jobalert_country = $('#jobseeker_alert_location_country_dashboard').val()
          var expected_salary_curr = $('#jobseeker_alert_expected_salary_currency_dashboard').val()
          var expected_salary = $('#jobseeker_alert_expected_salary_dashboard').val()
          var jobalert_email = $('#new_jobalert_email_dashboard').val()
          var jobalert_name = $('#new_jobalert_name_dashboard').val()
          var jobalert_contact = $('#new_jobalert_contact_dashboard').val()
          var job_type = $('#jobseeker_alert_jobtype_dashboard').val()
    		  var jobalert_dashboard_id = $('#jobalert_dashboard_id').val()
    		  jobalert_dashboard_id = parseInt(jobalert_dashboard_id)
    		  var rec_type = 'alert'
          var alert_status = ''

          var submitBtn = $('.savealert_dashboard')
          submitBtn.button('loading')
          
          // First Time Saving
          if (jobalert_dashboard_id == 0) {
            $.post(canvas_url + 'api/jobseeker/save-job-alert', { 'title': title, 'keywords': keywords, 'prefer_locations': prefer_locations, 'city': jobalert_city, 'country': jobalert_country, 'prefer_categories': prefer_categories, 'expected_salary': expected_salary, 'expected_salary_curr': expected_salary_curr, 'jobalert_email': jobalert_email, 'name': jobalert_name, 'jobalert_contact': jobalert_contact, 'alert_status': alert_status, job_type: job_type, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': 'POST' }, function (data) {
              if (data.status == 'success') {
                $('#jobalert_dashboard_id').val(data.id)
                submitBtn.button('reset') // reset button loading
                $('.modal').modal('hide') // close active modal

                swal({
                  title: 'Well Done',
                  text: txt_job_alert_saved_2,
                  type: 'success',
                  width: 450,
                  confirmButtonText: 'Ok, Thanks',
                  confirmButtonClass: 'btn btn-primary',
                  buttonsStyling: false
                })

                $.getJobsListing(0)
              } else {
                var text_message = ''
                for (i = 0; i < data.msg.length; i++) {
                  if (data.msg[i]) {
                    text_message += data.msg[i]
                  }
                }
                $.notify(text_message, { type: 'danger' })
                submitBtn.button('reset')
                submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load')
              }
            }, 'json')
    		  } else {
    			$.post(canvas_url + 'api/jobseeker/job-alert', { 'id': jobalert_dashboard_id, 'type': rec_type, 'title': title, 'keywords': keywords, 'prefer_locations': prefer_locations, 'city': jobalert_city, 'prefer_categories': prefer_categories, 'expected_salary': expected_salary, 'expected_salary_curr': expected_salary_curr, 'jobalert_email': jobalert_email, 'jobalert_contact': jobalert_contact, alert_status: alert_status, job_type: job_type, 'country': jobalert_country, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': 'PUT' }, function (data) {
              if (data.status == 'success') {
                submitBtn.button('reset') // reset button loading
                $('.modal').modal('hide') // close active modal

                swal({
                  title: 'Well Done',
                  text: txt_job_alert_saved_2,
                  type: 'success',
                  width: 450,
                  confirmButtonText: 'Ok, Thanks',
                  confirmButtonClass: 'btn btn-primary',
                  buttonsStyling: false
                })

                $.getJobsListing(0)

              } else {
                var text_message = ''
                for (i = 0; i < data.msg.length; i++) {
                  if (data.msg[i]) {
                    text_message += data.msg[i]
                  }
                }
                $.notify(text_message, { type: 'danger' })
                submitBtn.button('reset')
                submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load')
              }
            }, 'json')
    		  }
        }
      }).form()
    })

    

    $.getAppliedJobsDashboard(0)
    $.getSavedJobsDashboard(0)
    $.getWalkinJobsDashboard(0)

    // load on tab shown
    loadOnTabShown(['applied', 'saved', 'walkedin'])
  })
}

$(".saveexp2").bind("click", function () {

    $.validator.setDefaults( {
      submitHandler: function () {
        alert( "submitted!" );
      }
    });

    $( "#form_jobseeker_experience2" ).validate( {
      submitHandler: function() {

       var current_working = $("#currently_working").is(':checked');
       var no_exp = $("#no_experiance").is(':checked');
       var ae_company_name = $("#ae_company_name").val();
       var ae_title = $("#ae_title").val();
       var ae_salary_cur = $("#ae_salary_cur").val();
       var ae_salary = $("#ae_salary").val();
       var ae_start_date = $("#ae_start_date").val();
       var ae_end_date = $("#ae_end_date").val();
       var ae_job_description = $("#ae_job_description").val();
       var category_id = $("#category_id").val();
       var pageName = $('#pagename').val();

       var page = ["applyjob"];

       if (ae_title == '' && !no_exp)
       {
           $("#ae_title").focus();
           $("#ae_title").parents('.form-group').addClass("has-error");
           $.notify('Please Input Job Title', {type: 'danger'});
           return false;
       }

       if (category_id == '' && !no_exp)
       {
           $("#category_id").focus();
           $("#category_id").parents('.form-group').addClass("has-error");
           $.notify('Please Input Industry Type', {type: 'danger'});
           return false;
       }

       if (ae_company_name == '' && !no_exp)
       {
           $("#ae_company_name").focus();
           $("#ae_company_name").parents('.form-group').addClass("has-error");
           $.notify('Please Input Company Name', {type: 'danger'});
           return false;
       }

       if (ae_start_date == '' && !no_exp)
       {
           $("#ae_start_date").focus();
           $("#ae_start_date").parents('.form-group').addClass("has-error");
           $.notify('Please select Start Date', {type: 'danger'});
           return false;
       }

       if (ae_end_date=='' && !no_exp && !current_working)
       {
           $("#ae_end_date").focus();
           $("#ae_end_date").parents('.form-group').addClass("has-error");
           $.notify('Please select End Date', {type: 'danger'});
           return false;
       }
       if(no_exp)
       {
          ae_company_name = 'No Experience';
          ae_title = 'No Experience';
          ae_salary = '0';
          var today = new Date();
          var dd = today.getDate();

          var mm = today.getMonth()+1; 
          var yyyy = today.getFullYear();
          if(dd<10) 
          {
              dd='0'+dd;
          } 

          if(mm<10) 
          {
              mm='0'+mm;
          } 
          ae_start_date = dd+'/'+mm+'/'+yyyy;
          ae_end_date =  dd+'/'+mm+'/'+yyyy;
          ae_job_description = '-'
       }

       var submitBtn = $(".saveexp");
          submitBtn.button("loading");

        $.post(canvas_url + "api/jobseeker/experience", {'company_name': ae_company_name, 'title': ae_title, 'salary_cur': ae_salary_cur, 'salary': ae_salary, 'start_date': ae_start_date, 'end_date': ae_end_date, 'current_working': current_working, 'job_description': ae_job_description,'category_id': category_id, 'no_experiance' : no_exp ,'_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
              if (data.status == 'success') {
                if(pageName && page.indexOf(pageName) !== -1)
                {
                  submitBtn.button("reset"); 
                  $('.modal').modal('hide'); 
                  swal({
                    title: "Success",
                    //text: txt_exp_status_updated,
                    text: checkCompleteness(data.user_profile_completeness),
                    type: "success"
                  }).catch(swal.noop);


                  $("#experience_apply").load(location.href + " #experience_apply");
                }
                else
                {
                  submitBtn.button("reset"); 
                  $('.modal').modal('hide'); 
                  swal({
                    title: "Success",
                    //text: txt_exp_status_updated,
                    text: checkCompleteness(data.user_profile_completeness),
                    type: "success"
                  }).catch(swal.noop);

                  setTimeout(function () {
                      window.location = canvas_url + "jobseeker/mypage";
                  }, timeout_redirect);
                }
              } else {
                  var text_message = '';
                  for (i = 0; i < data.msg.length; i++) {
                      if (data.msg[i]) {
                          text_message += data.msg[i];
                      }
                  }
                  $.notify(text_message, {type: 'danger'});
                  submitBtn.button('reset');
                  submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
              }
          }, "json")
            .fail( function(xhr, textStatus, errorThrown) {
                submitBtn.button('reset');
                showErrorNotification(xhr.status)
            });
        }
    }).form();
});

$(".currentlyworkingcheckbox").bind("click", function () {
    var current_working = $("#currently_working").is(':checked');
    if (current_working === true)
    {
        $("#ae_end_date-div").fadeOut();
    } else
    {
        $("#ae_end_date-div").fadeIn();
    }
});


$('#form_jobseeker_skill').validate();

$('#form_jobseeker_skill').on('submit', function(event){
  event.preventDefault();
  
  $('input.jobseeker_skills').each(function() {
    $(this).rules("add",
      {
          required: true,
          normalizer: function(value) {
              return $.trim(value);
      }
    })
  });


  if($('#form_jobseeker_skill').valid()) {

      var jobseeker_skills = $(".jobseeker_skills").map(function () {
          return $(this).val();
      }).get();
      var jobseeker_skill_levels = $(".jobseeker_skill_levels").map(function () {
          return $(this).val();
      }).get();

      var submitBtn = $(this).parent().next().find('label');
      submitBtn.button("loading");

      $.post(canvas_url + "api/jobseeker/skills", {'type': 'skills', 'skills': jobseeker_skills, 'skill_levels': jobseeker_skill_levels, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {

          submitBtn.button("reset"); //reset button loading
          $('.modal').modal('hide'); // close active modal

          if (data.status == 'success') {

              swal({
                  title: "Success",
                  //text: 'You skills has been updated',
                  text: checkCompleteness(data.user_profile_completeness),
                  type: "success"
              }).catch(swal.noop);

              setTimeout(function () {
                  window.location = canvas_url + "jobseeker/mypage";
              }, timeout_redirect);

          } else {

              $.notify(data.msg, {type : 'danger'});
              submitBtn.button('reset');
              submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
          }
      }, "json")
      .fail( function(xhr, textStatus, errorThrown) {
          submitBtn.button('reset');
          showErrorNotification(xhr.status)
      });

    }
  });


  $(".adduserskill").click(function () {

    var userskillscount = $("#userskillscount").val();
    var label = $("#label-skills").text();
    userskillscount++;

    $("#userskillscount").val(userskillscount);

    var deletejob = '';
    if (userskillscount > 0) 
    {
      deletejob = '<a class="btn btn-circle btn-danger" data-id="' + userskillscount + '" onclick="$.deleteUserSkill(' + userskillscount + ');"><i class="fa fa-lg fa-trash-o"></i></a>';
    } 
    else 
    {
      deletejob = '';
      divider = '';
    }

    var html = '<div class="input-group-custom group center xs-mb-20" id="userskilldiv' + userskillscount + '">\
                    <div class="group auto sm-pr-20 xs-pr-10">\
                      <div class="form-group xs-mb-0">\
                        <input type="text" id="jobseeker_skill-'+userskillscount+'" name="jobseeker_skill'+userskillscount+'" class="form-control jobseeker_skills" placeholder="'+label+'">\
                      </div>\
                    </div>\
                    <div class="group">\
                      <div class="form-group xs-mb-0">\
                        '+deletejob+'\
                      </div>\
                    </div>\
                  </div>';


    $("#user_skills").append(html);

    $.deleteUserSkill = function (id) {
        $("#userskilldiv" + id).fadeOut("fast", function () {
            $("#userskilldiv" + id).remove();
        });
        var userskillscount = $("#userskillscount").val();
        userskillscount--;
        $("#userskillscount").val(userskillscount);
      };
    });

  function removeFromArray(original, remove) {
    for(var i=original.length - 1; i>=0; i--){
      for(var j=0; j<remove.length; j++){
          if(original[i] && (original[i] === remove[j])){
            original.splice(i, 1);
          }
        }
    }
    return original;
  }

  function addSkills(value)
  {
    var skill = value.split("#");
    var skillId = skill[0];
    var skillName = skill[1];
    var newSkills = '';
    var skillRecommendations = $("#skillRecommendations").val();

    var skillsElement = document.getElementsByClassName("jobseeker_skills");

    var pickedSkill = [];
    for(var i=0; i<skillsElement.length; i++) {
        pickedSkill.push(skillsElement[i].value);
    }

    var otherSkill = [];
    $('.skill-show').each(function(index,obj)
    {
      otherSkill.push($(this).text());
    });

    
    var allSkills = otherSkill.concat(pickedSkill);

    var newObject = removeFromArray(JSON.parse(skillRecommendations), allSkills);

    if(newObject.length > 0 && newObject !== 'undefined') 
    {
      var name = newObject[0];
      var skillParameter = skillId+'#'+name;
      newSkills = '<a class="btn btn-primary btn-outline skills-'+skillId+' skill-show" onclick="addSkills(\''+skillParameter+'\');">'+name+'</a>';
      $(".skills-"+skillId).replaceWith(newSkills);

    }
    else
    {
      $("#list-skills-div").hide();
    }
  
    var userskillscount = $("#userskillscount").val();
    
    userskillscount++;
   
    $("#userskillscount").val(userskillscount);
    
    var deletejob = '';
    if (userskillscount > 0) 
    {
      deletejob = '<a class="btn btn-circle btn-danger" data-id="' + userskillscount + '" onclick="$.deleteUserSkill(' + userskillscount + ');"><i class="fa fa-lg fa-trash-o"></i></a>';
    } 
    else 
    {
      deletejob = '';
      divider = '';
    }

    var html = '<div class="input-group-custom group center xs-mb-20" id="userskilldiv' + userskillscount + '">\
                    <div class="group auto sm-pr-20 xs-pr-10">\
                      <div class="form-group xs-mb-0">\
                        <input type="text" id="jobseeker_skill-'+userskillscount+'" name="jobseeker_skill'+userskillscount+'" class="form-control jobseeker_skills" value="'+skillName+'">\
                      </div>\
                    </div>\
                    <div class="group">\
                      <div class="form-group xs-mb-0">\
                        '+deletejob+'\
                      </div>\
                    </div>\
                  </div>';

    if (pickedSkill[0] == "") 
    {
      $("#user_skills").html(html);
    }
    else
    {
      $("#user_skills").append(html);
    }
    $.deleteUserSkill = function (id) {
        $("#userskilldiv" + id).fadeOut("fast", function () {
            $("#userskilldiv" + id).remove();
        });
        var userskillscount = $("#userskillscount").val();
        userskillscount--;
        $("#userskillscount").val(userskillscount);
      };

  }

  function checkCompleteness(completeness){
    if (typeof completeness == 'undefined') 
    {
      return false
    }
    else
    {
      var msg = '';
      var current_completeness = $('#profile_completeness').val();
      if(completeness > 90)
      {
        msg = 'Congrats! Employers will be able to view your profile and contact you directly';
      }
      else if(completeness < 90)
      {
        msg = 'Please make sure your profile is 100% complete to allow employers to search and contact you directly';
      }
      else if (completeness == 'undefined' || completeness == undefined)
      {
        msg = 'Congrats! Employers will be able to view your profile and contact you directly';
        completeness = current_completeness;
      }

      $('#profile_completeness_page, #profile_completeness_alert').html(completeness)

      return msg;
    }  
  }

function actionTimeline(id,action){
  var respon_yes = $('#txt_respon_yes').text();
  if(action == 'interested'){
      swal({
          title: intrsted_mdl_title,
          text: intrsted_mdl_ok,
          type: 'warning',
          width: 450,
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: intrsted_btn_yes,
          confirmButtonClass: 'btn btn-primary ',
          cancelButtonText: intrsted_btn_no,
          cancelButtonClass: 'btn btn-default xs-ml-20 '
      }).then(function () {
          var jsonData = {
            'status': 1,
            'id': id,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'PUT'
          }
          var request = $.ajax({
            url: canvas_url + 'api/jobseeker/appliedjobs/' + id,
            data: jsonData,
            type: 'PUT',
            crossDomain: true,
            dataType: 'json'
          })
          request.done(function (data) {
            if (data.status == 'success') {
              swal(intrsted_mdl_done, respon_yes, 'success')
              $("#action-timeline-area").hide();
              setTimeout(function () {
                window.location.reload();
              }, timeout_redirect);
            } else {
              swal('Opps', intrsted_mdl_ok_error, 'warning')
            }
          })

          request.fail(function (jqXHR, textStatus) {
            swal('Opps', intrsted_mdl_ok_error, 'warning')
          })

      }).catch(swal.noop)
  }else{
      swal({
            title: intrsted_mdl_title,
            text: intrsted_mdl_reject,
            type: 'warning',
            width: 450,
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: intrsted_btn_yes,
            confirmButtonClass: 'btn btn-primary',
            cancelButtonText: intrsted_btn_no,
            cancelButtonClass: 'btn btn-default xs-ml-20'
      }).then(function () {
            var jsonData = {
              'status': 0,
              'id': id,
              '_token': $('meta[name="csrf-token"]').attr('content'),
              '_method': 'PUT'
            }
            var request = $.ajax({
              url: canvas_url + 'api/jobseeker/appliedjobs/' + id,
              data: jsonData,
              type: 'PUT',
              crossDomain: true,
              dataType: 'json'
            })
            request.done(function (data) {
              if (data.status == 'success') {
                swal(intrsted_mdl_done, intrsted_mdl_reject_success, 'success')
                $("#action-timeline-area").hide();
                setTimeout(function () {
                  window.location.reload();
                }, timeout_redirect);
              } else {
                swal(intrsted_mdl_reject_success, 'warning')
              }
            })

            request.fail(function (jqXHR, textStatus) {
              swal(intrsted_mdl_reject_success, 'warning')
            })


      }).catch(swal.noop)
  }
}